module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ONE")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Artie")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THE BAY. IT DRAWS HER THESE LAST FEW NIGHTS OF HER DYING")]), _vm._v(". She rises from her bed that has been placed downstairs, and, careful not to wake Mrs. Randolph, opens the front door and steps onto the porch.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She is weak, but the pain is distant, like a thunderstorm held at the horizon. She crosses the yard slowly and rests at the top of the steps that lead to the beach. The air is warm, moist, and still. She feels it settling around her. Then slowly she begins her descent. Sea oats brush against her hands as she clasps the railing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She pulls off her nightgown, folds it on the last step, and crosses the narrow beach to the water. The sand is cool to her bare feet, but the water is warm and quiet as bathwater. She walks into it and sits down, then lies back, one arm beneath her head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The moon is a cup spilling out stars. Was it Papa who had said that once? Or had she read it? It doesn’t matter. She sees that it is true. Stars drop from the sky, burning, into the bay.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She could sleep here like a baby in its sea of amni"), _c('a', {
    attrs: {
      "id": "page2"
    }
  }), _vm._v("otic fluid. Sometimes she thinks she remembers what that was like, floating with Donnie in Sarah’s belly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sarah.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Artie closes her eyes and sees them all: Donnie, her other half, Carl, her husband, Bo, her love, Dolly, child of her heart, Hektor, Zeke Pardue, Papa, Mama.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Warp and woof of her life. But, on these last few nights of her dying, it is Sarah, her mother, that Artie longs for.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When she sits up, water pools in the bony conclaves of her body. She holds her palms together, fills them with water, and, bending, pours the water slowly over her head.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3574bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 72
// module chunks = 0